'use client';

import { Modal } from '#/components/ui/modal';
import { Button } from '#/components/ui/button';
import { useAlertModal } from '#/hooks/use-alert-modal';
import { Icons } from '../icons';
import { useMounted } from '#/hooks';

export const AlertModal = () => {
  const {
    title,
    description,
    contents,
    type,
    isOpen,
    onConfirm,
    close,
    loading,
    isDelete,
    width
  } = useAlertModal();
  const mounted = useMounted();

  if (!mounted) {
    return null;
  }
  console.log(width);
  return (
    <Modal
      title={title}
      description={description}
      isOpen={isOpen}
      onClose={close}
      className={`gap-4 max-h-[70vh] sm:max-h-[80vh] overflow-y-auto   ${width} `}
      classNames={{
        header: 'space-y-2'
      }}
    >
      {contents}
      <div className="space-x-2 flex items-center justify-end w-full">
        {type === 'error' ||
          (type === 'confirm' && (
            <Button disabled={loading} variant="outline" onClick={close}>
              취소
            </Button>
          ))}
        <Button
          disabled={loading}
          variant={type === 'error' ? 'destructive' : 'default'}
          onClick={onConfirm}
        >
          {loading && <Icons.spinner className="btn-spinner-with-text" />}
          {isDelete ? '삭제' : '확인'}
        </Button>
      </div>
    </Modal>
  );
};
